<template>
  <div class="after-sale-video">
    <div class="after-sale-back">
      <!-- <h1>安视康产品中心</h1> -->

      <div class="wrapper-text wrapper">
        <img src="@/assets/img/page/after_sale_icon.png" alt="">
        <span>产品使用中心</span>
      </div>

      <div class="wrapper-subtext wrapper">
        <span>机器安装</span>
        <span>操作指引</span>
        <span>设备维护</span>
      </div>
    </div>

    <div class="wrapper wrapper-machine">
      <template v-for="(project) in tableData" :key="project.name">
        <div @click="toVideoDetail(project)" class="video-card">
          <img :src="project.filePath" alt="">
          <div>
            <div class="title">{{ project.title }}</div>
            <div class="sub-title">{{ project.notes }}</div>
          </div>
          <div>
            <img src="@/assets/img/mobile/page/routerpush-icon.png" alt="" class="jump">
          </div>
        </div>
      </template>
    </div>


  </div>
</template>

<script>
import { defineComponent, onActivated } from 'vue';
import { videoList } from './data';
import { useRouter } from 'vue-router';
import { getProductVideoList } from '@/request/view/afterSale.js';
import { reactive } from 'vue';

export default defineComponent({
  setup() {
    const router = useRouter();

    const tableData = reactive([]);

    const getvideoData = () => {
      getProductVideoList().then((res) => {
        if (res.code === 200 && res.data && res.data.length > 0) {
          const newData = res.data.filter(item => item.productType !== '星豚')
          tableData.push(...newData)
        }
      })
    }

    const toVideoDetail = (e) => {
      const { title, productType } = e;
      router.push({
        path: '/aftersalevideodetail',
        query: {
          type: title,
          productType
        }
      });
    }

    onActivated(() => {
      document.title = '安视康产品使用中心';
    });

    getvideoData();

    return {
      videoList,
      tableData,
      toVideoDetail
    };
  }
});
</script>

<style lang="less" scoped>
.after-sale-video {
  width: 100vw;
  height: 100vh;
  background: #F7F8FB;

  .wrapper {
    padding: 0 0.30998rem;
  }

  .after-sale-back {
    width: 100%;
    height: 5.44000rem;
    background: url('../../../assets/img/page/after_sale_home.png');
    background-size: 100% 100%;
    padding-top: 0.42001rem;
    .wrapper-text {
      img {
        width: 0.77001rem;
        height: 0.77001rem;
        margin-right: 0.26000rem;
      }

      font-size: 0.77001rem;
      color: #FFFFFF;
      margin-bottom: 0.12998rem;
    }

    .wrapper-subtext {
      font-size: 0.30998rem;
      color: #FFFFFF;

      span {
        margin-right: 0.19999rem;
      }
    }
  }

  h1 {
    text-align: center;
    padding-top: 0.67002rem;
    font-size: 0.45999rem;
    color: #FFFFFF;
    text-align: center;
    letter-spacing: 1px;
  }

  .wrapper-machine {
    margin-top: -2.77000rem;

    .video-card {
      display: flex;
      padding: 10px;
      align-items: center;
      width: 9.20999rem;
      height: 2.51000rem;
      border-radius: 0.15001rem;
      box-shadow: 0 0 1px 0 #F0F4F9;
      background: #fff;
      margin-bottom: 0.26000rem;

      img {
        width: 1.70999rem;
        height: 1.44000rem;
        margin-right: 10px;
      }

      .jump {
        width: 0.50001rem;
        height: 0.76002rem;
      }

      .title {
        font-size: 0.45999rem;
        color: #333333;
      }

      .sub-title {
        font-size: 0.30998rem;
        color: #999999;
        width: 5.50001rem;
      }
    }
  }


}
</style>
